<!--
 * @Date: 2024-04-10 16:36:50
 * @LastEditTime: 2024-06-05 09:43:47
-->
<template>
  <div
    style="background-color: #f4fbff"
    :style="{ height: this.noticeListShow ? '' : '100vh' }"
  >
    <Header
      :leftArrow="false"
      :leftText="''"
      @leftClick="onClickLeft"
      @onRefreshClick="onRefresh"
      :rightIcons="true"
      :pageTitle="userInfo.name"
    >
    </Header>
    <div class="home">
      <div class="wrap home_notice-area" v-show="noticeListShow">
        <div class="home_area-head">
          <p class="area-title">新着通知</p>
        </div>
        <section class="home_notice-list">
          <div
            class="notice-list_area notice-list_area-no"
            v-show="noticeList.length == 0"
          >
            <p class="notice-list_no">新着通知はありません</p>
          </div>
          <div
            class="notice-list_area"
            :style="{ height: this.openShow ? '100%' : '' }"
            v-show="noticeList.length != 0"
            style="align-content: flex-start"
          >
            <div class="notice-list-item"
              v-for="(item, index) in noticeListSlice"
              :key="index"
              @click="chickNotice(item)"
              :class="[getNoticeClass(item.calling_type)]">
              <div v-if="item.calling_type == 'smartPeep'" :class="[getAIStatusColor(item.ai_status)]">
                <button class="delete-btn" @click.stop="deleteNotice(item)">×</button>
                <div class="ai-header">
                  <div class="status">{{getAIStatusName(item.ai_status)}}</div>
                  <div class="time">{{item.time}}</div>
                </div>
                <div class="ai-content">
                  <div class="icon">
                    <img v-if="item.ai_status == '2'" src="@/assets/img/ai/status_2.svg"/>
                    <img v-else-if="item.ai_status == '3'" src="@/assets/img/ai/status_3.svg"/>
                    <img v-else-if="item.ai_status == '4'" src="@/assets/img/ai/status_4.svg"/>
                    <img v-else-if="item.ai_status == '5'" src="@/assets/img/ai/status_5.svg"/>
                    <img v-else-if="item.ai_status == '6'" src="@/assets/img/ai/status_6.svg"/>
                  </div>
                  <div class="name">{{item.name}}</div>
                </div>
              </div>
              <div v-else-if="item.calling_type == 'smartPeepNotice'" :class="[getAINoticeStatusColor(item.smartpeep_status)]">
                <button class="delete-btn" @click.stop="deleteNotice(item)">×</button>
                <div class="ai-header">
                  <div class="status">不在着信</div>
                  <div class="time">{{item.time}}</div>
                </div>
                <div class="ai-content">
                  <div class="icon">
                    <img v-if="item.smartpeep_status == '2'" src="@/assets/img/ai/status_2.svg"/>
                    <img v-else-if="item.smartpeep_status == '3'" src="@/assets/img/ai/status_3.svg"/>
                    <img v-else-if="item.smartpeep_status == '4'" src="@/assets/img/ai/status_4.svg"/>
                    <img v-else-if="item.smartpeep_status == '5'" src="@/assets/img/ai/status_5.svg"/>
                    <img v-else-if="item.smartpeep_status == '6'" src="@/assets/img/ai/status_6_white.svg"/>
                  </div>
                  <div class="name">{{item.name}}<br/>&#9654;{{getAIStatusName(item.smartpeep_status)}}</div>
                </div>
              </div>
              <div v-else>
                <button class="delete-btn" @click.stop="deleteNotice(item)">×</button>
                <div style="display: flex">
                  <p class="item-message" v-if="item.aams" >aams通知</p>
                  <p class="item-message" v-else>{{ item.calling_type }}</p>
                  <van-loading
                      v-if="item.calling_type == '呼出中'"
                      color="blue" size="18px" type="circular"/>
                </div>

                <p class="item-data">
                  <!-- <span class="item-day">2/13</span> -->
                  <span class="item-time">{{ item.created_at }}</span>
                </p>
                <p class="item-room">
                  <span class="item-room-name" >{{ item.name }}</span>
                  <span v-if="item.aams" class="item-room-name" style="margin-top: 5px">
                  {{ item.calling_type }}
                </span>
                  <span v-if="item.calling_type == '通話中'" class="item-room-name" style="margin-top: 5px">
                  {{ item.doctor_name }}
                </span>
                </p>
              </div>
            </div>
          </div>
          <div class="notice-list_more">
            <div
              class="open-label"
              v-show="!openShow && noticeList.length > 4"
              @click="openNoticeList">
              すべての新着通知を表示
            </div>
            <div
              class="open-label-close"
              v-show="openShow && noticeList.length != 0"
              @click="closeNoticeList"
            >
              折り畳み
            </div>
          </div>
        </section>
      </div>

      <div
        class="wrap home_menu-area clear"
        style="margin-top: 20px"
        v-show="noticeListShow"
      >
        <div
          class="home_menu-item income"
          @click="goToPage('audioBridgeList')"
          style="width: 100%; height: 80px"
          v-show="userInfo.auth_list.includes('audiobridge')"
        >
          <span class="home_menu-txt">インカム</span>
        </div>
      </div>

      <div
        class="wrap home_menu-area clear"
        style="margin-top: 20px"
        v-show="noticeListShow"
      >
        <!--        v-if="userInfo.auth_list.includes('sensor')"-->
        <div
          class="home_menu-item sensor"
          @click="goToPage('sensor')"
          v-if="false"
        >
          <span class="home_menu-txt">センサー一覧</span>
        </div>
        <div
          class="home_menu-item watch"
          @click="goToPage('monitorList')"
          v-if="userInfo.auth_list.includes('monitor')"
        >
          <span class="home_menu-txt">見守りモード</span>
        </div>
        <div
          class="home_menu-item user"
          @click="goToPage('PatientList')"
          v-if="userInfo.auth_list.includes('call')"
        >
          <span class="home_menu-txt">ユーザー一覧</span>
        </div>
        <div
          class="home_menu-item tel"
          @click="goToPage('teamList')"
          v-if="userInfo.auth_list.includes('room')"
        >
          <span class="home_menu-txt">通話</span>
        </div>
        <div
          class="home_menu-item all"
          @click="goToPage('notice')"
          v-if="false"
        >
          <span class="home_menu-txt">センサー通知一覧</span>
        </div>
        <div
          class="home_menu-item log"
          @click="goToPage('log')"
          v-if="userInfo.auth_list.includes('log')"
        >
          <span class="home_menu-txt">各種ログ</span>
        </div>
        <div
          class="home_menu-item movie"
          @click="goToPage('recordLog')"
          v-if="userInfo.auth_list.includes('video')"
        >
          <span class="home_menu-txt">録画一覧</span>
        </div>
        <div
          class="home_menu-item single-user"
          @click="goToPage('chatToPatient')"
          v-if="userInfo.auth_list.includes('notice')"
        >
          <span class="home_menu-txt">テキスト送信</span>
        </div>
        <!-- <div
          class="home_menu-item room"
          @click="goToPage('roomList')"
          v-if="userInfo.auth_list.includes('addRoom')"
        >
          <span class="home_menu-txt">ルーム一覧</span>
        </div> -->
        <div
          class="home_menu-item room-reserve"
          @click="goToPage('roomCalendar')"
          v-if="userInfo.auth_list.includes('room')"
        >
          <span class="home_menu-txt">ルーム一覧</span>
        </div>
        <div
          class="home_menu-item calendar"
          @click="goToPage('userCalendar')"
          v-if="userInfo.auth_list.includes('room')"
        >
          <span class="home_menu-txt">個人スケジュール</span>
        </div>
        <div
          class="home_menu-item ai-analysis"
          @click="goToPage('aiAnalysis')"
          v-if="userInfo.auth_list.includes('ai')"
        >
          <span class="home_menu-txt">AI分析管理</span>
        </div>
      </div>
    </div>

    <van-dialog
        v-model:show="refreshModelShow"
        :closeOnClickOverlay="true"
        :showConfirmButton="true"
        :showCancelButton="true"
        @confirm="refreshPatient"
    >
      <div id="tel-popup active">
        <div class="tel-popup_inner">
          <p class="tel-popup_row">
            <span class="tel-popup_name">{{ chooseItem.name }}</span>
          </p>
          <div>
            リフレッシュをします。よろしいですか？
          </div>
        </div>
      </div>
    </van-dialog>

    <van-dialog
      v-model:show="chooseCallFlg"
      :closeOnClickOverlay="true"
      :showConfirmButton="false"
      :showCancelButton="false"
    >
      <div id="tel-popup active">
        <div class="tel-popup_inner">
          <p class="tel-popup_row">
            <span class="tel-popup_name">{{ chooseItem.name }}</span>
          </p>
          <div class="tel-popup_row tel-popup_btn-area">
            <div class="tel-popup_btn-area-div">
              <div class="tel-popup_btn voice" @click="call('audio')">
                音声通話
              </div>
              <div class="tel-popup_btn video" @click="call('video')">
                ビデオ通話
              </div>
            </div>
            <div class="tel-popup_btn-area-div tel-popup_btn-area-div-bottom" v-show="chooseItem.call_type == 1" @click="showRefreshModel()">
              リフレッシュ
            </div>
          </div>
        </div>
      </div>
    </van-dialog>
    <Footer />
  </div>
</template>

<script>
import Footer from "@/components/Footer.vue";
import Header from "@/components/Header.vue";
import { RefreshUserInfo } from "@/services/login";
import {GetNoticeList, NoticeDelete, refreshApp, SmartPeepNoticeDelete} from "@/services/user";
import { Toast } from "vant";
import "vant/es/toast/style";
import { Dialog } from "vant";
import { Loading } from "vant";

import "vant/es/dialog/style";
import {getAIStatusName} from "@/utils/getName";

export default {
  data() {
    return {
      show: false,
      userInfo: {
        auth_list: [],
      },
      noticeList: [],
      noticeListShow: false,
      openShow: false,
      chooseItem: null,
      chooseCallFlg: false,
      refreshNoticeTimer: null,
      refreshModelShow: false,
    };
  },
  components: {
    Footer,
    Header,
    [Loading.name]: Loading,
  },
  crated() {},
  beforeUnmount() {
    if (this.refreshNoticeTimer) {
      clearInterval(this.refreshNoticeTimer);
    }
  },
  mounted() {
    RefreshUserInfo().then((res) => {
      this.userInfo = res.data.data.user;
      console.log(this.userInfo);
    });
    window.initNoticeList = this.getNoticeList;
    this.getNoticeList();
    this.refreshNoticeTimer = setInterval(() => {
      this.getNoticeList();
    }, 2500);
  },
  methods: {
    showRefreshModel() {
      this.refreshModelShow = true;
    },
    async refreshPatient() {
      const res = await refreshApp({account_ids:[this.chooseItem.patient_id]});
      if(res.data.code >= 0){
        Toast.success("リフレッシュ成功");
      }else{
        Toast.fail("リフレッシュ失敗");
      }
    },
    getAIStatusName(status){
      return getAIStatusName(status);
    },
    getAIStatusColor(status){
      switch (status){
        case "2":
        case "3":
        case "4":
          return 'ai-blue'
        case "5":
          return 'ai-yellow'
        case "6":
          return 'ai-red'
        default :
          return 'ai-blue';
      }
    },
    getAINoticeStatusColor(status){
      // 目前只有状态6打电话 先做一种
      switch (status){
        case "2":
        case "3":
        case "4":
        case "5":
        case "6":
          return 'ai-notice-red'
        default :
          return 'ai-notice-red';
      }
    },
    getNoticeClass(type){
      switch (type){
        case '通話中':
        case '呼出中':
        case '見守りモード':
          return 'item-case__talking';
        case '⼼拍上昇':
          return 'item-case__beat-up';
        case '⼼拍低下':
          return 'item-case__beat-down';
        case '呼吸上昇':
          return 'item-case__breathing-up';
        case '呼吸低下':
          return 'item-case__breathing-down';
        case '離床':
          return 'item-case__leaving-bed-new';
        case '体動（中）':
        case '体動（小）':
        case '体動（大）':
          return 'item-case__body-move-error';
        case '⻑時間無体動':
          return 'item-case__no-body-move-new';
        case '離床予測':
          return 'item-case__leave-bed-forecast';
        case '通信エラー':
          return 'item-case__net-error';
        case 'smartPeep':
        case 'smartPeepNotice':
          return 'item-case__smartPeep';
        default :
          return 'item-case__machine-anomaly';
      }
    },
    getNoticeList() {
      GetNoticeList().then((res) => {
        this.noticeList = res.data.data;
        this.noticeListShow = true;
      });
    },
    hangup() {
      this.show = false;
    },
    onClickLeft() {
      history.back();
    },
    goToPage(pageName) {
      const routes = {
        PatientList: "/PatientList",
        log: "/log",
        teamList: "/teamList",
        monitorList: "/monitorList",
        sensor: "/sensor",
        recordLog: "/recordLog",
        audioBridgeList: "/audioBridgeList",
        notice: "/notice",
        chatToPatient: "/chatToPatient",
        roomList: "/roomList",
        userCalendar: "/userCalendar",
        roomCalendar: "/roomCalendar",
        aiAnalysis: '/aiAnalysis'
      };
      const route = routes[pageName];
      if (route) {
        this.$router.push(route);
      }
    },
    onRefresh() {
      Toast.loading({
        message: "",
        forbidClick: true,
        duration: 1000,
      });
    },
    openNoticeList() {
      this.openShow = true;
    },
    closeNoticeList() {
      this.openShow = false;
    },
    chickNotice(item) {
      if(item.aams){
        // aams不需要点击
        return;
      }
      if (item.calling_type !== "通話中") {
        this.chooseItem = item;
        this.chooseCallFlg = true;
      }
    },
    deleteNotice(item) {
      Dialog.confirm({
        title: "",
        message: "削除しますか",
      }).then(() => {
          if(item.calling_type == 'smartPeep'){
            // smartPeep削除（删除redis）
            SmartPeepNoticeDelete({ patient_id: item.patient_id }).then((result) => {
              if (result.data.code >= 0) {
                Toast("削除しました。");
              } else {
                Toast("削除できませんでした。");
              }
              this.getNoticeList();
            });
          }else{
            NoticeDelete({ ids: [item.logcall_sort_id] }).then((result) => {
              if (result.data.code >= 0) {
                Toast("削除しました。");
              } else {
                Toast("削除できませんでした。");
              }
              this.getNoticeList();
            });
          }
        }).catch(() => {
          // on cancel
        });
    },
    call(type) {
      this.chooseItem["type"] = "patient";
      this.chooseItem["id"] = this.chooseItem.patient_id;
      if (type != "audio") {
        this.$router.push({
          path: "/beforeCall",
          query: {
            type: this.chooseItem.type,
            chooseItem_id: this.chooseItem.id,
          },
        });
        return;
      }
      this.chooseCallFlg = false;
      this.$emit("callUser", type, this.chooseItem);
    },
  },
  watch: {},
  computed: {
    noticeListSlice: function () {
      return this.noticeList.slice(0, 10);
    },
  },
};
</script>

<style scoped>
.delete-btn {
  position: absolute;
  top: 7px;
  right: 10px;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background-color: #fff;
  color: rgb(233, 9, 9);
  font-size: 17px;
  font-weight: bold;
  cursor: pointer;
  border: none;
  outline: none;
}
.item-case__smartPeep{
  background: #fff;
  padding :0;
}
.item-case__smartPeep{
  color:#646872;
}
.item-case__smartPeep::after {
  content:none;
}
.item-case__smartPeep .delete-btn {
  background-color: #646872 !important;
  color: #fff !important;
}
.item-case__smartPeep .ai-header{
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}
.ai-blue .status{
  background-color: #63B2BF;
}
.ai-yellow .status{
  background-color: #F1B167;
}
.ai-red {
  background-color: #E14242;
  color:white;
}
.ai-red .delete-btn{
  background-color: white !important;
  color: #E14242 !important;
}
.ai-red .status{
  border-right: white 3px solid;
  border-bottom: white 3px solid;
}
.item-case__smartPeep .status{
  color:white;
  font-weight: 700;
  font-size: 14px;
  line-height: 1.5;
  margin-bottom: 5px;
  min-width:100px;
  display: inline-block;
  text-align: center;
  border-bottom-right-radius: 6px;
  padding: 3px 0;
}
.item-case__smartPeep .time{
  white-space: nowrap;
  padding :0 25px 0 5px;
}
.item-case__smartPeep .ai-content{
  display: flex;
  align-items: center;
}
.item-case__smartPeep .ai-content .name{
  font-weight: 700;
  font-size: 17px;
}

.ai-notice-red .status{
  background-color: #E85F5F;
}


</style>
